import { render, staticRenderFns } from "./TagsPreviewDialog.vue?vue&type=template&id=773634e1&scoped=true&"
import script from "./TagsPreviewDialog.vue?vue&type=script&lang=js&"
export * from "./TagsPreviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./TagsPreviewDialog.vue?vue&type=style&index=0&id=773634e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773634e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
